import { SheetPortalContent } from '@web/sheets/sheet-portal-content'
import type { CSSProperties, ReactNode } from 'react'
import { Drawer } from 'vaul'

type SheetDrawerPortalProps = {
  portalContainer?: HTMLElement | null
  isBodyPortal: boolean
  overlayStyle: CSSProperties
  centeredHostStyle: CSSProperties
  children: ReactNode
}

export function SheetDrawerPortal({
  portalContainer,
  isBodyPortal,
  overlayStyle,
  centeredHostStyle,
  children,
}: SheetDrawerPortalProps) {
  return (
    <Drawer.Portal container={portalContainer}>
      <Drawer.Overlay style={overlayStyle} />
      <SheetPortalContent isBodyPortal={isBodyPortal} centeredHostStyle={centeredHostStyle}>
        {children}
      </SheetPortalContent>
    </Drawer.Portal>
  )
}
